import { Component, Input, OnChanges, ElementRef } from '@angular/core';
import { CompareData } from './text-compare.model';
import CodeMirror from 'codemirror';
import 'codemirror/addon/merge/merge'; // Explicitly import the addon

@Component({
    selector: 'cpq-text-compare',
    templateUrl: './cpq-text-compare.component.html',
    styleUrls: ['./cpq-text-compare.component.scss'],
    standalone: false
})
export class CpqTextCompareComponent implements OnChanges {

  @Input('originalObject') originalObject: CompareData;
  @Input('compareObject') compareObject: CompareData;

  constructor(private el: ElementRef) { }

  ngOnChanges() {
    if (this.originalObject && this.compareObject) {
      const target = document.getElementById('codeMirrorContainer');
      CodeMirror.MergeView(target, {
        value: this.originalObject.content,
        origLeft: null,
        orig: this.compareObject.content,
        lineNumbers: true,
        mode: "text/html",
        highlightDifferences: true,
        lineWrapping: true,
        readOnly: true,
        cursorHeight: 0,
        revertButtons: false
      });
      this.el.nativeElement.scrollIntoView({ block: 'end', behavior: 'smooth' });
    }
  }

}
